// apps/web/src/stores/sidebar.ts
// Per. Persists `collapsed: boolean` to localStorage['magimp:sidebar-collapsed'].
import { create } from 'zustand';

interface SidebarState {
  collapsed: boolean;
  toggle: () => void;
}

function readInitial(): boolean {
  try {
    return localStorage.getItem('magimp:sidebar-collapsed') === '1';
  } catch {
    return false;
  }
}

export const useSidebarStore = create<SidebarState>((set, get) => ({
  collapsed: readInitial(),
  toggle: () => {
    const next = !get().collapsed;
    try {
      localStorage.setItem('magimp:sidebar-collapsed', next ? '1' : '0');
    } catch {
      // Non-fatal — see theme.ts rationale.
    }
    set({ collapsed: next });
  },
}));
